export const getGranTotal = (totalPrice, couponDiscount) => {
  const couponDiscountValue = totalPrice * (couponDiscount / 100);
  const totalPriceWithCoupon = couponDiscount ? totalPrice - couponDiscountValue : totalPrice;

  return { couponDiscountValue, totalPriceWithCoupon };
};
